import React from 'react';
import { Accelerometer } from 'expo-sensors';

const SHAKE_SENSITIVITY = 2;

export const useShakeMonitor = (onShake: () => void) => {
  const [isAvailable, setIsAvailable] = React.useState(false);

  React.useEffect(() => {
    void Accelerometer.isAvailableAsync().then(setIsAvailable);

    if (!isAvailable) return;
    Accelerometer.setUpdateInterval(500);
    Accelerometer.addListener((event) => {
      const acceleration = getAverageAcceleration(event);

      if (acceleration >= SHAKE_SENSITIVITY) onShake();
    });

    return () => {
      Accelerometer.removeAllListeners();
    };
  }, [isAvailable, onShake]);
};

const getAverageAcceleration = ({
  x,
  y,
  z,
}: {
  readonly x: number;
  readonly y: number;
  readonly z: number;
}) => {
  return Math.sqrt(x * x + y * y + z * z);
};
